export default {
  last_update: state => state.last_update
};
